import { useState, useEffect } from 'react';
import { isMobile } from './src-utils-mobile-utils.js';
import { getOperatingSystem, getBrowserName } from './src-utils-app-utils.js';

function useKeyboardAwareFooter(footerRef) {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
  useEffect(() => {
    const footer = footerRef.current;
    if (!footer) return;
    if (!isMobile()) {
      return;
    }
    const handleViewportResize = () => {
      try {
        const viewport = window.visualViewport;
        if (!viewport) return;
        const offset = window.innerHeight - viewport.height;
        const threshold = Math.max(100, window.innerHeight * 0.2);
        if (offset > threshold) {
          setIsKeyboardOpen(true);
          footer.style.transform = `translateY(-${offset}px)`;
        } else {
          setIsKeyboardOpen(false);
          footer.style.transform = "translateY(0)";
        }
      } catch (error) {
        console.error("Error handling viewport resize:", error);
      }
    };
    const input = footer.querySelector("textarea");
    const handleFocus = () => {
      if (getBrowserName() == "Safari") setIsKeyboardOpen(true);
    };
    const handleBlur = () => {
      if (getOperatingSystem() == "Safari") setIsKeyboardOpen(false);
    };
    input?.addEventListener("focus", handleFocus);
    input?.addEventListener("blur", handleBlur);
    if ("visualViewport" in window && window.visualViewport && getOperatingSystem() !== "Safari") {
      window.visualViewport.addEventListener("resize", handleViewportResize);
    }
    return () => {
      input?.removeEventListener("focus", handleFocus);
      input?.removeEventListener("blur", handleBlur);
      window.visualViewport?.removeEventListener("resize", handleViewportResize);
    };
  }, [footerRef]);
  return isKeyboardOpen;
}

export { useKeyboardAwareFooter };
//# sourceMappingURL=src-components-ChatWindow-ChatFooter-useFooterRef.js.map
